import { createApi } from '@reduxjs/toolkit/query/react';
import { userAxiosQuery } from '../../utils/axios/user.axios';

export interface WidgetColorsPayload {
	agent: string;
	clientId: string;
	textColor?: string;
	primaryColor?: string;
	secondaryColor?: string;
	file?: File;
}

export interface WidgetContentQuestion {
	index: number;
	question: string;
}

export interface WidgetContentPayload {
	agent: string;
	clientId: string;
	welcomeMessage?: string;
	questions?: WidgetContentQuestion[];
}

export const widgetConfigApi = createApi({
	reducerPath: 'widgetConfig',
	baseQuery: userAxiosQuery(),
	tagTypes: ['WidgetConfig'],
	endpoints: (builder) => ({
		getWidgetConfig: builder.query<any, { agentId: string, clientId: string }>({
			query: ({ agentId, clientId }: { agentId: string, clientId: string }) => ({
				url: `/widget-config-dom/${agentId}/client/${clientId}`,
				method: 'GET',
			}),
			providesTags: (result, error, { agentId, clientId }) => [{ type: 'WidgetConfig', id: `${agentId}-${clientId}` }],
		}),
		updateWidgetColors: builder.mutation<any, WidgetColorsPayload>({
			query: ({ agent, clientId, ...rest }) => {
				const formData = new FormData();
				formData.append('agent', agent);
				formData.append('clientId', clientId);
				if (rest.primaryColor) formData.append('primaryColor', rest.primaryColor);
				if (rest.secondaryColor) formData.append('secondaryColor', rest.secondaryColor);
				if (rest.textColor) formData.append('textColor', rest.textColor);
				if (rest.file) formData.append('file', rest.file);

				return {
					url: '/widget-config/create-colors',
					method: 'POST',
					data: formData,
				};
			},
			invalidatesTags: (result, error, { agent, clientId }) => [{ type: 'WidgetConfig', id: `${agent}-${clientId}` }],
		}),
		updateWidgetContent: builder.mutation<any, WidgetContentPayload>({
			query: (body) => ({
				url: '/widget-config/create-content',
				method: 'POST',
				data: body,
			}),
			invalidatesTags: (result, error, { agent, clientId }) => [{ type: 'WidgetConfig', id: `${agent}-${clientId}` }],
		}),
	}),
});

export const {
	useGetWidgetConfigQuery,
	useUpdateWidgetColorsMutation,
	useUpdateWidgetContentMutation,
} = widgetConfigApi;

